import { render, staticRenderFns } from "./MenuRecommendationDetail.vue?vue&type=template&id=526d7162&scoped=true&"
import script from "./MenuRecommendationDetail.vue?vue&type=script&lang=js&"
export * from "./MenuRecommendationDetail.vue?vue&type=script&lang=js&"
import style0 from "./MenuRecommendationDetail.vue?vue&type=style&index=0&id=526d7162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526d7162",
  null
  
)

/* custom blocks */
import block0 from "./MenuRecommendationDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})
